import { DOUBLE, TRIPLE } from "../../../constants/numbers.consts.js";
export default {
    defaultProps: {
        enterTouchDelay: 0, //ensures that tooltip appears on touch, without the default 750ms delay
        leaveTouchDelay: 5000, //ensures that tooltip will be visible more than the default of 1500ms
    },
    styleOverrides: {
        tooltip: ({ theme }) => ({
            whiteSpace: "pre-line",
            fontSize: "14px",
            fontWeight: 400,
            padding: theme.spacing(DOUBLE, TRIPLE),
            borderRadius: theme.spacing(DOUBLE),
        }),
    },
};
